$.widget("bluaul.BufferList", $.common.VisualBase, {
    _create: function () {
        var me = this;
        try {
            /**
            * set the Visual-Name first
            * after that execute the parent function (_super())
            * to load the visual into the root-element
            */
            me.options.invoke.name = "VISUAL2_BUFFER_LIST";
            me._super();
        } catch (e) {
            me.writeError('_create', e); return false; 
        } 
        return true;
    },
    _initHTML: function () {
        var me = this;
        try {
            //init vcDate into a vcOptionBox
            me.element.find(".navigation .vc-date-box").vcDateBox({
                mode: "Range",
                align: "right",
                interval: 1,
                defaultRange: { from: moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").subtract(7, 'days').format("DD.MM.YYYY"), to: moment(me.options.invoke.date, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY") },
                langID: me.settings.userLangIDForCulture,
                callback: function () { }
            });

            /**
             * get current Dropdown into variable and replace with vcOptionBox with it inside
             */
            var DropdownDbTable = me.element.find(".navigation .db-table").clone();

            me.element.find(".navigation .db-table").replaceWith(
                $("<div>").addClass("db-table-box vc-grid-2col vc-grid-margin-right")
            );
            me.element.find(".navigation .db-table-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.tableView, clickable: false, isList: false, content: DropdownDbTable.clone() }]
            });

            /**
             * get current Dropdown into variable and replace with vcOptionBox with it inside
             */
            var DropdownSignalType = me.element.find(".navigation .signal-type").clone();

            me.element.find(".navigation .signal-type").replaceWith(
                $("<div>").addClass("signal-type-box vc-grid-2col vc-grid-margin-right")
            );
            me.element.find(".navigation .signal-type-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.resources.status, clickable: false, isList: false, content: DropdownSignalType.clone() }]
            });

            /**
             * get current Dropdown into variable and replace with vcOptionBox with it inside
             */
            var DropdownUserAction = me.element.find(".navigation-interaction .user-action").clone();

            me.element.find(".navigation-interaction .user-action").replaceWith(
                $("<div>").addClass("user-action-box vc-grid-2col vc-grid-margin-right")
            );
            me.element.find(".navigation-interaction .user-action-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.action, clickable: false, isList: false, content: DropdownUserAction }]
            });

            //initialize vcOptionBox with vcFilterElement(not complete initialized) inside
            me.visual.find(".navigation .vc-filter-box").vcOptionBox({
                caption: me.specific.resources.filterBoxCaption,
                items: [{ button: me.specific.resources.filterBoxButton, clickable: false, isList: false, content: $("<div>").addClass("vc-filter")[0].outerHTML }]
            });

            //initialize filter-function (more bound to element itself and has more to do with the initialisation, thats why its not in the _initEvents() function)
            me.visual.find(".navigation .vc-filter").vcFilter({ callback: function () { me._filter() } });

            //calculate height for elements in visual
            //var navigation = me.element.find(" .navigation");
            //var checkAll = me.element.find(" .check-all-container");
            var dataListHeight = me.element.height() - 208; // me.element.height() - navigation.height() - checkAll.height();

            me.element.find(".data-list").height(dataListHeight);

            /**
             * _fillTableContent() is a function that loads data into the displayed-table             *
             * execute for the first time that the user doesnt sit infront of a empty screen
             */
            me._fillTableContent();
        } catch (e) {
            me.writeError('_initHTML', e); return false; 
        } 
        return true;
    },
    _initEvents: function () {
        var me = this;
        try {
            //event to commit user actions (delete/set to other bufferstatus)
            me.element.on("click", ".navigation-interaction .action-commit", function () {
                try {
                    var action = JSON.parse(me.element.find(".navigation-interaction .user-action-box .user-action").val());

                    switch (action.type.toUpperCase()) {
                        case "UPDATE":
                            me._updateData("UPDATE", action.value);
                            break;
                        case "DELETE":
                            me._updateData("DELETE");
                            break;
                        default:
                    }

                    me.element.find("#check-all-" + me.vcgid).prop("checked", false); //uncheck the check-all-checkbox to "reset" it
                } catch (e) {
                    me.writeError('_initEvents.onClick.action-commit', e); return false; 
                }
                me._fillTableContent(); //load table again
                return true;
            });
            //event to change the used db-table
            me.element.on("change", ".navigation .signal-type, .navigation .db-table", function () {
                //if the selected table is "signal_analog_in_dirty" there is no other useraction than delete,
                //also there is no bufferstatus, so the options for the status-select get hidden and the select disabled
                if ($(this).val() === "signal_analog_in_dirty") {
                    me.element.find(".navigation .navigation-interaction .user-action option").each(function () {
                        if (JSON.parse($(this).val()).type.toUpperCase() != "DELETE") {
                            $(this).attr("selected", false)
                            $(this).hide();
                        } else {
                            $(this).attr("selected", "selected")
                        }
                    });
                    me.element.find(".navigation .signal-type").prop("disabled", true);
                    me.element.find(".navigation .signal-type option").each(function () {
                        $(this).attr("selected", false)
                        $(this).hide();
                    });
                } else {
                    //unblock all useractions
                    me.element.find(".navigation .navigation-interaction .user-action option").each(function () {
                        $(this).show();
                    });
                    me.element.find(".navigation .signal-type").prop("disabled", false);
                    me.element.find(".navigation .signal-type option").each(function (i) {
                        if (i === 0) { $(this).attr("selected", "selected") }
                        $(this).show();
                    });
                }
                me._fillTableContent();
                me.element.find("#check-all-" + me.vcgid).prop("checked", false); //uncheck the check-all-checkbox to "reset" it
            });
            //load table again
            me.element.on("click", ".navigation-interaction .reload", function () {
                me._fillTableContent(); //load table again
                me.element.find("#check-all-" + me.vcgid).prop("checked", false); //uncheck the check-all-checkbox to "reset" it
            });
            //select all visible entrys - visible is important, you dont want to delete entrys that are hidden because of the filter-search
            me.element.on("click", "#check-all-" + me.vcgid, function () {
                if ($(this).is(":checked")) {
                    me.element.find(".data-list-content .vc-list-item:visible").addClass("selected");
                } else {
                    me.element.find(".data-list-content .vc-list-item").removeClass("selected");
                }
            });
            //set list entry to selected by clicking
            me.element.on("click", ".data-list-content .vc-list-item", function () {
                if ($(this).hasClass("selected")) {
                    $(this).removeClass("selected");
                } else {
                    $(this).addClass("selected");
                }
            });
        } catch (e) {
            me.writeError('_initEvents', e); return false;
        }
        return true;
    },
    _fillTableContent: function () {
        var me = this;
        try {

            var dateRange = me.element.find(".navigation .vc-date").vcDate("getDate");

            //set param for ajax request
            var param = {
                Table: me._getCurrentTable(),
                BufferStatus: me.element.find(".navigation .signal-type").children("option:selected").val(),
                StartDate: dateRange.from,
                EndDate: dateRange.to
            };

            //set loading icon on begin
            me.element.find(".data-list-content").html(me.getLoadingIcon());
            
            me.getData(param, function (result) {
                //updating table-header - different db-tables contain different data
                switch (me._getCurrentTable()) {
                    case "signal_analog_archive":
                        me.element.find(".data-list .data-list-header").html("").append($("<div>", { "class": "vc-list-item" }).append($("<div>", { "class": "vc-list-col" }).append(
                            $("<div>", { "class": "vc-list-col-element date-short" }).html(me.specific.resources.date),
                            $("<div>", { "class": "vc-list-col-element text-long" }).html(me.specific.resources.project),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.signal),
                            $("<div>", { "class": "vc-list-col-element number" }).html(me.specific.resources.meterReading),
                            $("<div>", { "class": "vc-list-col-element number-short" }).html("Mkorr"),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.state),
                            $("<div>", { "class": "vc-list-col-element date" }).html(me.specific.resources.timestamp)
                        )));
                        break;
                    case "signal_analog_in":
                        me.element.find(".data-list .data-list-header").html("").append($("<div>", { "class": "vc-list-item" }).append($("<div>", { "class": "vc-list-col" }).append(
                            $("<div>", { "class": "vc-list-col-element date-short" }).html(me.specific.resources.date),
                            $("<div>", { "class": "vc-list-col-element text-long" }).html(me.specific.resources.project),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.signal),
                            $("<div>", { "class": "vc-list-col-element number-short" }).html("Mkorr")
                        )));
                        break;
                    case "signal_analog_in_dirty":
                        me.element.find(".data-list .data-list-header").html("").append($("<div>", { "class": "vc-list-item" }).append($("<div>", { "class": "vc-list-col" }).append(
                            $("<div>", { "class": "vc-list-col-element date-short" }).html(me.specific.resources.date),
                            $("<div>", { "class": "vc-list-col-element text-long" }).html(me.specific.resources.project),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.signal),
                            $("<div>", { "class": "vc-list-col-element number-short" }).html("Mkorr")
                        )));
                        break;
                    case "signal_digital_archive":
                        me.element.find(".data-list .data-list-header").html("").append($("<div>", { "class": "vc-list-item" }).append($("<div>", { "class": "vc-list-col" }).append(
                            $("<div>", { "class": "vc-list-col-element text-long" }).html(me.specific.resources.project),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.signal),
                            $("<div>", { "class": "vc-list-col-element text-long-long" }).html(me.specific.resources.state),
                            $("<div>", { "class": "vc-list-col-element date" }).html(me.specific.resources.timestamp)
                        )));
                        break;
                    default:
                }

                //check response content
                if (result === {}) {
                    me.element.find(".data-list-content.vc-list-table").html(me.resources.err_loadData);
                    me.writeError('fillTableContent', "empty result"); return false;
                } else if (result.length < 1) {
                    me.element.find(".data-list-content.vc-list-table").html(me.resources.noEntriesExist);
                    return false;
                }

                //update table-content
                var table = $("<div>").addClass("vc-list-table");

                switch (me._getCurrentTable()) {
                    case "signal_analog_archive":
                        result.forEach(function (row) {
                            table.append($("<div>", { "class": "vc-list-item" }));
                            //if an odd amount of rows exist, the last row gets an additional class to change display
                            if (table.find("> div").length % 2 !== 0) {
                                table.find("> div:last").addClass("alt");
                            }
                            //append data into last row
                            //there are some ternary statements in the append function,
                            //they just check if the data exists and is not empty, if thats true it returns the value, otherwise an ampty string (condition ? if true do ... : if false do ...)
                            table.find("> div:last").append(
                                $("<div>", { "class": "vc-list-col" }).append(
                                    $("<div>", {
                                        "class": "vc-list-col-element date-short" 
                                    }).html(row.SignalDate),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long",                                        
                                        "title": "ID: " + row.ProjectId + (row.LoggerUnitId !== undefined && row.LoggerUnitId.length > 0 ? " (" + row.LoggerUnitId + ")" : "") 
                                    }).html(row.ProjectName + (row.LoggerUnit !== undefined && row.LoggerUnit.length > 0 ? " (" + row.LoggerUnit + ")" : "")),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long-long", 
                                        "title": "ID: " + row.SignalId + (row.MeasureUnitId !== undefined && row.MeasureUnitId.length > 0 ? " [" + row.MeasureUnitId + "]" : "") 
                                    }).html(row.SignalName + (row.MeasureUnit !== undefined && row.MeasureUnit.length > 0 ? " [" + row.MeasureUnit + "]" : "")),
                                    $("<div>", {
                                        "class": "vc-list-col-element number" 
                                    }).html(me.formatNumber(row.Zst, 4)),
                                    $("<div>", { 
                                        "class": "vc-list-col-element number-short" 
                                    }).html(me.formatNumber(row.Mkorr, 4)),
                                    $("<div>", { 
                                        "class": "vc-list-col-element text-long-long" 
                                    }).html(row.StateMessage),
                                    $("<div>", {
                                        "class": "vc-list-col-element date"
                                    }).html(row.Timestamp)
                                )
                            );
                            table.find("> div:last .vc-list-col").attr("data-entryId", row.EntryID);
                        });
                        break;
                    case "signal_analog_in":
                        result.forEach(function (row) {
                            table.append($("<div>", { "class": "vc-list-item" }));
                            //if an odd amount of rows exist, the last row gets an additional class to change display
                            if (table.find("> div").length % 2 !== 0) {
                                table.find("> div:last", { "class": "alt" });
                            }
                            //append data into last row
                            table.find("> div:last").append(
                                $("<div>", { "class": "vc-list-col" }).append(
                                    $("<div>", { 
                                        "class": "vc-list-col-element date-short" 
                                    }).html(row.SignalDate),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long", 
                                        "title": "ID: " + row.ProjectId + (row.LoggerUnitId !== undefined && row.LoggerUnitId.length > 0 ? " (" + row.LoggerUnitId + ")" : "" ) 
                                    }).html(row.ProjectName + (row.LoggerUnit !== undefined && row.LoggerUnit.length > 0 ? " (" + row.LoggerUnit + ")" : "")),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long-long", 
                                        "title": "ID: " + row.SignalId + (row.MeasureUnitId !== undefined && row.MeasureUnitId.length > 0 ? " [" + row.MeasureUnitId + "]" : "") 
                                    }).html(row.SignalName + (row.MeasureUnit !== undefined && row.MeasureUnit.length > 0 ? " [" + row.MeasureUnit + "]" : "")),
                                    $("<div>", { 
                                        "class": "vc-list-col-element number-short" 
                                    }).html(me.formatNumber(row.Mkorr, 4))
                                )
                            );
                            table.find("> div:last .vc-list-col").attr("data-entryId", row.EntryID);
                        });
                        break;
                    case "signal_analog_in_dirty":
                        result.forEach(function (row) {
                            table.append($("<div>", { "class": "vc-list-item" }));

                            //if an odd amount of rows exist, the last row gets an additional class to change display
                            if (table.find("> div").length % 2 !== 0) {
                                table.find("> div:last").addClass("alt");
                            }
                            //append data into last row
                            table.find("> div:last").append(
                                $("<div>", { "class": "vc-list-col" }).append(
                                    $("<div>", {
                                        "class": "vc-list-col-element date-short"
                                    }).html(row.SignalDate),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long", 
                                        "title": "ID: " + row.ProjectId
                                    }).html(row.ProjectName),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long-long", 
                                        "title": "ID: " + row.SignalId + (row.MeasureUnitId !== undefined && row.MeasureUnitId.length > 0 ? " [" + row.MeasureUnitId + "]" : "") 
                                    }).html(row.SignalName + (row.MeasureUnit !== undefined && row.MeasureUnit.length > 0 ? " [" + row.MeasureUnit + "]" : "")),
                                    $("<div>", {
                                        "class": "vc-list-col-element number-short"
                                    }).html(me.formatNumber(row.Mkorr, 4))
                                )
                            );
                            table.find("> div:last .vc-list-col").attr("data-entryId", row.EntryID);
                        });
                        break;
                    case "signal_digital_archive":
                        result.forEach(function (row) {
                            table.append($("<div>").addClass("vc-list-item"));

                            //if an odd amount of rows exist, the last row gets an additional class to change display
                            if (table.find("> div").length % 2 !== 0) {
                                table.find("> div:last").addClass("alt");
                            }
                            //append data into last row
                            table.find("> div:last").append(
                                $("<div>", {
                                    "class": "vc-list-col"
                                }).append(
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long", 
                                        "title": "ID: " + row.ProjectId + (row.LoggerUnitId !== undefined && row.LoggerUnitId.length > 0 ? " (" + row.LoggerUnitId + ")" : "" ) 
                                }).html(row.ProjectName + (row.LoggerUnit !== undefined && row.LoggerUnit.length > 0 ? " (" + row.LoggerUnit + ")" : "")),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long-long", 
                                        "title": "ID: " + row.SignalId
                                    }).html(row.SignalName),
                                    $("<div>", {
                                        "class": "vc-list-col-element text-long-long"
                                    }).html(row.StateMessage),
                                    $("<div>", {
                                        "class": "vc-list-col-element date"
                                    }).html(row.Timestamp)
                                )
                            );
                            table.find("> div:last .vc-list-col").attr("data-entryId", row.EntryID);
                        });
                        break;
                    default:
                }                
                me.element.find(".data-list-content").html(table.html());
                //END update table-content
            });
        } catch (e) {
            me.writeError('_fillTableContent', e); return false; 
        }
        return true;
    },
    _updateData: function (action, value) {
        var me = this;
        try {
            action = action.toUpperCase();

            var toUpdate = me.element.find(".data-list-content .vc-list-item.selected");
            if (toUpdate.length < 1) {
                return false;
            }
            var toUpdateObjectList = [];

            toUpdate.each(function () {
                toUpdateObjectList.push(
                    { EntryID: $(this).find(".vc-list-col").data("entryid") /*get id's of selected rows */}
                );
            });

            //set param for ajax request
            switch (action) {
                case "UPDATE":             
                    if (value === undefined) {
                        value = -1;
                    }
                    var param = {
                        Table: me._getCurrentTable(),
                        BufferStatus: value,
                        UpdateAction: action,
                        UpdateData: JSON.stringify(toUpdateObjectList)
                    };
                    break;
                case "DELETE":
                    var param = {
                        Table: me._getCurrentTable(),
                        UpdateAction: action,
                        UpdateData: JSON.stringify(toUpdateObjectList)
                    };
                    break;
                default:
                    me.writeError('updateData', "unknown action"); return false; 
                    break;
            }

            me.updateData(param, function () { });
        } catch (e) {
            me.writeError('_updateData', e); return false; 
        }
        return true;
    },
    //returns the current selection from the bt-table dropdown
    _getCurrentTable: function () {
        var me = this;
        try {
            return me.element.find(".navigation .db-table option:selected").val();
        } catch (e) {
            me.writeError('_getCurrentTable', e); return false; 
        }       
    },
    _filter: function () {
        /// <summary>
        /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }

            //hide all
            me.element.find(".data-list-content .vc-list-item").removeClass("found").data("counter", 0).hide();

            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(".vc-filter", ".data-list-content .vc-list-item", "found");

            me.element.find(".data-list-content .vc-list-item.found").show();
            me.element.find(".data-list-content .vc-list-item").removeClass("alt");
            me.element.find(".data-list-content .vc-list-item.found:even").addClass("alt");

            return true;
        } catch (e) {
            me.writeError('_filter', e); return false;
        }
    }
});
